import { UserModel, type IUserModel } from "models/user/shared/UserModel";

export interface ICustomerModel extends IUserModel {
  cardFullName: string;
}

export class CustomerModel extends UserModel {
  cardFullName: string;

  constructor(data: ICustomerModel) {
    super(data);
    this.cardFullName = data.firstName.split(" ")[0] + " " + data.lastName.split(" ")[0];
  }
}